import { eDmChuyenNganhActionsObj } from "../../action-types/category/IDmChuyenNganhActions";
import { generateActions } from "../generateActions";

export const chuyenNganhActions = {
  ...generateActions(eDmChuyenNganhActionsObj, "CHUYEN_NGANH"),
};
